import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./common/ProtectedRoute"; 
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";

import UserAccounts from "./scenes/useraccounts";
import Subscriptions from "./scenes/subscriptions";

import Landing from "./pages/landing";
import Login from "./pages/login";
import Logout from "./pages/logout";
import Reset from "./pages/reset";
import Signup from "./pages/signup";
import ContactUs from "./pages/contactus";
import Subscribe from "./pages/subscribe";
import Pricing from "./pages/pricing";
import CheckoutSuccess from "./pages/subscribe/steps/checkoutsuccess";
import CheckoutCancelled from "./pages/subscribe/steps/checkoutcancel";
import CheckoutSuccessDodo from "./pages/subscribe/steps/checkoutsuccessdodo";
import CheckoutCancelledDodo from "./pages/subscribe/steps/checkoutcanceldodo";

import ConfirmMarketingOptIn from "./pages/confirmmarketingoptin";

import PaidMarketingLandingPage from "./pages/paidmarketinglandingpage";

import PaidMarketingLandingPageReddit from "./pages/paidmarketinglandingpagereddit";

import  OptOutOfMarketingEmails from "./pages/optoutmarketingemails";

import  OptOutOfPPCMarketingEmails from "./pages/optoutppcmarketingemails";

import  DemoPage from "./pages/demopage";

import TermsOfService from "./pages/termsofservice";

import Dashboard from "./scenes/dashboard";

import Unauthorized from "./scenes/unauthorized";

import NotFound from "./pages/pagenotfound";

import Staff from "./scenes/staff";
import Customers from "./scenes/customers";
import Students from "./scenes/students";
import Instructors from "./scenes/instructors";
import Courses from "./scenes/courses";
import TaskManagement from "./scenes/taskmanagement";
import TaskManagementByStatus from "./scenes/taskmanagement/indexByStatus";
import TaskManagementByPriority from "./scenes/taskmanagement/indexByPriority";
import Events from "./scenes/events";
import CostumeManagement from "./scenes/costumemanagement";
import CostumeManagementByRentalStatus from "./scenes/costumemanagement/indexByRentalStatus";
import RecitalPlanning from "./scenes/recitalplanning";
import AttendanceTracking from "./scenes/attendancetracking";
import BillingInvoices from "./scenes/billinginvoices";
import BillingInvoicesByStatus from "./scenes/billinginvoices/indexByStatus";
import BillingInvoicesByCurrency from "./scenes/billinginvoices/indexByCurrency";
import Registration from "./scenes/registration";
import RegistrationByConfirmationStatus from "./scenes/registration/indexByConfirmationStatus";
import RoboMailer from "./scenes/robomailer";
import RoboMailerByStatus from "./scenes/robomailer/indexByStatus";
import RoboMailerByEmailType from "./scenes/robomailer/indexByEmailType";
import Inventory from "./scenes/inventory";


import ToastMessageDisplay from "./common/ToastMessageDisplay"; 
import { UserProvider } from "./common/UserContext";
import { ApplicationModeProvider } from "./common/ApplicationModeContext";
import { UserCountProvider } from "./common/UserCountContext";
import { AccountProvider } from "./common/AccountContext";

import Bar from "./scenes/bar";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import { Navigate } from "react-router-dom";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");  // Add this line to hold the search term
  const location = useLocation();

  const publicPaths = ["/", 
    "/index.html", 
    "/login", 
    "/logout", 
    "/reset", 
    "/signup",
    "/contactus", 
    "/subscribe", 
    "/pricing", 
    "/terms-of-service", 
    "/confirm-marketing-opt-in",
    "/opt-out-of-marketing-emails",
    "/opt-out-of-ppc-marketing-emails",
    "/checkout-success", 
    "/checkout-cancelled",
    "/checkout-dodo-success", 
    "/checkout-dodo-cancelled",

    "/not-found",
    "/limited-time-discount-offer",
    "/demo",
    "/i-built-a-tool"];

  const isPublic = publicPaths.includes(location.pathname);

/************************************ PUBLIC PAGES ********************************************* */

if (isPublic) {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/index.html" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/confirm-marketing-opt-in" element={<ConfirmMarketingOptIn />} />
      <Route path="/opt-out-of-marketing-emails" element={<OptOutOfMarketingEmails />} />
      <Route path="/opt-out-of-ppc-marketing-emails" element={<OptOutOfPPCMarketingEmails />} />
      <Route path="/limited-time-discount-offer" element={<PaidMarketingLandingPage />} />
      <Route path="/i-built-a-tool" element={<PaidMarketingLandingPageReddit />} />
      <Route path="/demo" element={<DemoPage />} />

      <Route path="/checkout-success" element={<CheckoutSuccess />} />
      <Route path="/checkout-cancelled" element={<CheckoutCancelled />} />
      <Route path="/checkout-dodo-success" element={<CheckoutSuccessDodo />} />
      <Route path="/checkout-dodo-cancelled" element={<CheckoutCancelledDodo />} />

      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/************************************ PRIVATE PAGES ********************************************* */

  return (
    <ApplicationModeProvider>  
      <UserProvider>
        <UserCountProvider>
          <AccountProvider>
            <ColorModeContext.Provider value={colorMode}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <div className="app">
                  <Sidebar isSidebar={isSidebar} />
                  <main className="content">
                    <Topbar setIsSidebar={setIsSidebar} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                    <Routes>
                      <Route path="/app" element={<ProtectedRoute element={<Dashboard />} />} />

                      <Route path="/staff" element={<ProtectedRoute element={<Staff searchTerm={searchTerm} />} />} />
<Route path="/customers" element={<ProtectedRoute element={<Customers searchTerm={searchTerm} />} />} />
<Route path="/students" element={<ProtectedRoute element={<Students searchTerm={searchTerm} />} />} />
<Route path="/instructors" element={<ProtectedRoute element={<Instructors searchTerm={searchTerm} />} />} />
<Route path="/courses" element={<ProtectedRoute element={<Courses searchTerm={searchTerm} />} />} />
<Route path="/taskmanagement" element={<ProtectedRoute element={<TaskManagement searchTerm={searchTerm} />} />} />
<Route path="/taskmanagement/list" element={<ProtectedRoute element={<TaskManagement searchTerm={searchTerm} />} />} />
<Route path="/taskmanagement/status" element={<ProtectedRoute element={<TaskManagementByStatus searchTerm={searchTerm} />} />} />
<Route path="/taskmanagement/priority" element={<ProtectedRoute element={<TaskManagementByPriority searchTerm={searchTerm} />} />} />
<Route path="/events" element={<ProtectedRoute element={<Events searchTerm={searchTerm} />} />} />
<Route path="/events/list" element={<ProtectedRoute element={<Events searchTerm={searchTerm} />} />} />
<Route path="/costumemanagement" element={<ProtectedRoute element={<CostumeManagement searchTerm={searchTerm} />} />} />
<Route path="/costumemanagement/list" element={<ProtectedRoute element={<CostumeManagement searchTerm={searchTerm} />} />} />
<Route path="/costumemanagement/rentalstatus" element={<ProtectedRoute element={<CostumeManagementByRentalStatus searchTerm={searchTerm} />} />} />
<Route path="/recitalplanning" element={<ProtectedRoute element={<RecitalPlanning searchTerm={searchTerm} />} />} />
<Route path="/recitalplanning/list" element={<ProtectedRoute element={<RecitalPlanning searchTerm={searchTerm} />} />} />
<Route path="/attendancetracking" element={<ProtectedRoute element={<AttendanceTracking searchTerm={searchTerm} />} />} />
<Route path="/attendancetracking/list" element={<ProtectedRoute element={<AttendanceTracking searchTerm={searchTerm} />} />} />
<Route path="/billinginvoices" element={<ProtectedRoute element={<BillingInvoices searchTerm={searchTerm} />} />} />
<Route path="/billinginvoices/list" element={<ProtectedRoute element={<BillingInvoices searchTerm={searchTerm} />} />} />
<Route path="/billinginvoices/status" element={<ProtectedRoute element={<BillingInvoicesByStatus searchTerm={searchTerm} />} />} />
<Route path="/billinginvoices/currency" element={<ProtectedRoute element={<BillingInvoicesByCurrency searchTerm={searchTerm} />} />} />
<Route path="/registration" element={<ProtectedRoute element={<Registration searchTerm={searchTerm} />} />} />
<Route path="/registration/list" element={<ProtectedRoute element={<Registration searchTerm={searchTerm} />} />} />
<Route path="/registration/confirmationstatus" element={<ProtectedRoute element={<RegistrationByConfirmationStatus searchTerm={searchTerm} />} />} />
<Route path="/robomailer" element={<ProtectedRoute element={<RoboMailer searchTerm={searchTerm} />} />} />
<Route path="/robomailer/list" element={<ProtectedRoute element={<RoboMailer searchTerm={searchTerm} />} />} />
<Route path="/robomailer/status" element={<ProtectedRoute element={<RoboMailerByStatus searchTerm={searchTerm} />} />} />
<Route path="/robomailer/emailtype" element={<ProtectedRoute element={<RoboMailerByEmailType searchTerm={searchTerm} />} />} />
<Route path="/inventory" element={<ProtectedRoute element={<Inventory searchTerm={searchTerm} />} />} />
<Route path="/inventory/list" element={<ProtectedRoute element={<Inventory searchTerm={searchTerm} />} />} />


                      <Route path="/pie" element={<ProtectedRoute element={<Pie />} />} />
                      <Route path="/line" element={<ProtectedRoute element={<Line />} />} />
                      <Route path="/calendar" element={<ProtectedRoute element={<Calendar />} />} />
                      <Route path="/geography" element={<ProtectedRoute element={<Geography />} />} />

                      <Route path="/useraccounts" element={<ProtectedRoute element={<UserAccounts />} role="admin" />} />
                      <Route path="/subscriptions" element={<ProtectedRoute element={<Subscriptions />} role="admin" />} />

                      <Route path="/unauthorized" element={<ProtectedRoute element={<Unauthorized />} />} />

                      <Route path="*" element={<Navigate to="/not-found" replace />} />

                    </Routes>
                    <ToastMessageDisplay />
                  </main>
                </div>
              </ThemeProvider>
            </ColorModeContext.Provider>
            </AccountProvider>
        </UserCountProvider>
      </UserProvider>
    </ApplicationModeProvider>
  );
}

export default App;
